import { render, staticRenderFns } from "./SendActivationLinkAround.vue?vue&type=template&id=a18164f2&scoped=true"
import script from "./SendActivationLinkAround.vue?vue&type=script&lang=js"
export * from "./SendActivationLinkAround.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18164f2",
  null
  
)

export default component.exports